module.exports = __webpack_public_path__ + "static/media/FlashIcon.fc523a83.svg";